import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import EmailTemplates from "../Components/Email Temaplates/Email";

const EmailTemplatesRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');
  const hasPermission = canAdd || canEdit;
  return (
    <Routes>
      <Route path="/email_templates" element={canAdd ? <EmailTemplates /> : <Navigate to="/dashboard" replace />}></Route>
    </Routes>
  );
};

export default EmailTemplatesRoutes;
